import type { ResponsiveImageSrc } from "@medbillai/ui";

export const CARD_FAN = {
  web: "/static/referral/card-fan.png",
  native: require("../../assets/referral/card-fan.png"),
} satisfies ResponsiveImageSrc;

export const CARDS = {
  web: "/static/referral/cards.png",
  native: require("../../assets/referral/cards.png"),
} satisfies ResponsiveImageSrc;

export const ART = {
  web: "/static/referral/art.jpg",
  native: require("../../assets/referral/art.jpg"),
} satisfies ResponsiveImageSrc;
